import axios from 'axios';

export const LOCATION_ERROR = 'LOCATION_ERROR';
export const LOCATION_SUCCESS = 'LOCATION_SUCCESS';
export const FETCH_LOCATIONS = 'FETCH_LOCATIONS';
export const SET_LOCATION = 'SET_LOCATION';
export const SET_TRANSACTION_ACCOUNT = 'SET_TRANSACTION_ACCOUNT';
export const SET_DEFAULT_TRANSACTION_ACCOUNT = 'SET_DEFAULT_TRANSACTION_ACCOUNT';

export const fetchLocations = merchantId => async (dispatch, getState) => {
  try {
    const response = await axios.get(`/api/merchants/${merchantId}/locations/active`);
    dispatch({ type: FETCH_LOCATIONS, payload: response.data });
  } catch (error) {
    dispatch({ type: LOCATION_ERROR, payload: error.response });
  }
};
export const selectLocation = location => async (dispatch, getState) => {
  dispatch({ type: SET_LOCATION, payload: location });
};

export const selectTransactionAccount = location => async (dispatch, getState) => {
  dispatch({ type: SET_TRANSACTION_ACCOUNT, payload: location });
};

export const setDefaultTrxAct = user => async (dispatch, getState) => {
  dispatch({ type: SET_DEFAULT_TRANSACTION_ACCOUNT, payload: user });
};
